import React, { useState } from "react";
import PropTypes from "prop-types";

import "./NEQ.scss";

export default function NEQ(props) {
  // const [checked, setChecked] = useState(null);
  // useEffect(()=>{
  //   choices.map((option, index) => {
  //     if (option.checked && option.correct !== null) {
  //       setChecked(index)
  //     }
  //   });
  // })

  const [correct, setCorrect] = useState(null);
  const [anyResponse, setAnyResponse] = useState(false);
  const [response, setResponse] = useState(null);

  const [attempts, setAttempts] = useState(props.attempts);

  const validateNEQ = () => {
    if (parseFloat(response) === props.answer) {
      setCorrect(true);
    } else {
      setCorrect(false);
    }

    setAttempts(attempts - 1);
  };

  const numsOnly = (text) => {
    return text.replace(/[^0-9.]/g, "");
  };

  const textChanged = (index, e) => {
    let temp = response;
    temp = e.target.value;
    temp = numsOnly(e.target.value);

    if (e.target.value !== temp) {
      e.target.setCustomValidity("Please input an integer");
      e.target.reportValidity();
    } else {
      e.target.setCustomValidity("");
    }

    if (temp !== "") {
      setAnyResponse(true);
    } else {
      setAnyResponse(true);
    }

    setResponse(temp);
  };

  return (
    <div className="numericEntryQuestion">
      <p
        className="label"
        aria-label={"Question " + props.id + ", " + props.label}
      >
        {props.label}
      </p>
      <input
        className={
          "text-field" +
          (correct === null ? "" : correct ? " correct" : " incorrect")
        }
        style={{ width: "100%", marginBottom: "16px", height: "30px" }}
        type="text"
        disabled={correct}
        placeholder="Type your answer here"
        onChange={(e) => textChanged(props.id, e)}
        value={response}
      />
      <div
        className="feedback"
        style={{
          display:
            Object.hasOwn(props, "feedback") && props.feedback !== ""
              ? "initial"
              : "none",
        }}
      >
        <p style={{ margin: 0 }}>
          {correct === null
            ? ""
            : correct
              ? "Feedback: Correct."
              : "Feedback: " + props.feedback}
        </p>
      </div>
      <div className="question-footer">
        <p>{"Attempts left: " + attempts}</p>
        <button
          onClick={validateNEQ}
          disabled={
            (attempts > 0 || attempts === "unlimited") &&
            (correct === false ||
              correct === null ||
              attempts === "unlimited") &&
            anyResponse
              ? false
              : true
          }
        >
          Submit answer
        </button>
      </div>
    </div>
  );
}
NEQ.propTypes = {
  id: PropTypes.number,
  label: PropTypes.string,
  attempts: PropTypes.number,
  answer: PropTypes.number,
  feedback: PropTypes.string,
  //response: PropTypes.string,
  //anyResponse: PropTypes.boolean,
  //correct: PropTypes.boolean
};
